import { UserInfo } from 'react-scale/components/ExpertManagement/ExpertManagementPage/types';
import { create } from 'zustand';

type UserInfoState = {
  userInfo: UserInfo | undefined;
  setUserInfo: (userInfo: UserInfo | undefined) => void;
};

export const useUserInfoStore = create<UserInfoState>(set => ({
  userInfo: undefined,
  setUserInfo: userInfo => set(() => ({ userInfo })),
}));

export const userInfoSelector = (state: UserInfoState): UserInfoState['userInfo'] => state.userInfo;
export const setUserInfoSelector = (state: UserInfoState): UserInfoState['setUserInfo'] =>
  state.setUserInfo;
